export const WmsType = {
  InventoryTransfer: 31,
  PurchaseDelivery: 12,
  Delivery: 22,
};

export const WmsStatus = {
  OPENED: 'O',
  CLOSED: 'C',
};
